import { getDisplayNameForPrizeCategory } from 'utils/WeeklyDrawPrizeSubcategoryHelperMethods';
import { colors } from 'utils/constants';

const SubcategoryPill = ({ subcategory, selected, onClick }) => {
  const displayName = subcategory
    ? getDisplayNameForPrizeCategory(subcategory, true)
    : 'All';
  return (
    <div
      className={`subcategoryPill${selected ? ' selected' : ''}`}
      onClick={onClick}
    >
      {displayName}

      <style jsx>
        {`
          .subcategoryPill {
            cursor: ${selected ? 'default' : 'pointer'};
            padding: 0.8em 1.3em;
            border-radius: 1.8em;
            border: 2px solid #bbb;
            color: #aaa;
            text-transform: capitalize;
            font-weight: 700;
            transition: 0.3s;
            flex-grow: 1;
            text-align: center;
            margin: 0.5em;
          }

          .subcategoryPill.selected {
            color: ${colors.primaryBrandGray};
            border: 2px solid ${colors.primaryBrandGray};
          }
        `}
      </style>
    </div>
  );
};

export default SubcategoryPill;
